/**
 * Shared ECharts styling tokens for the analytics page.
 *
 * ECharts renders into its own SVG/canvas and does NOT inherit the CSS custom
 * properties (`--av2-*`) used everywhere else, so font and colors must be passed
 * to it as literal values. The palette below mirrors the light-theme tokens in
 * `analyticsV2.scss` and must be kept in sync with them. This page is light-only
 * (no dark mode), so static literals are safe.
 */

/** Mirrors `--av2-font` from analyticsV2.scss. */
export const AV2_FONT =
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export const AV2_CHART = {
    font: AV2_FONT,
    accent: '#1e3a5f', //        --av2-accent
    ghost: '#94a3b8', //         --av2-text-tertiary (dashed previous line)
    textPrimary: '#0f172a', //   --av2-text-primary
    textSecondary: '#475569', // --av2-text-secondary
    textTertiary: '#94a3b8', //  --av2-text-tertiary
    border: '#e2e8f0', //        --av2-border
    borderStrong: '#cbd5e1', //  --av2-border-strong
    tooltipBg: '#0f172a', //     --av2-text-primary (dark surface for tooltips)
};
